// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"880fc890","73":"bed7a9c0","171":"ef139de6","432":"fdde5b27","653":"b1e89c66","845":"d12104c5"}[chunkId] + ".chunk.js";
};